import clsx from "clsx"
import { ComponentChildren } from "preact"

interface StatCardProps {
  type: string
  children: ComponentChildren
  background: string
}

const StatCard = ({ type, children, background }: StatCardProps) => {
  return (
    <div
      data-type={type}
      className={clsx(
        "w-72 h-96 px-10 py-14 rounded-2xl inline-flex flex-col justify-start items-start gap-6 overflow-hidden bg-cover bg-center",
        background,
      )}
    >
      <div className="self-stretch opacity-80 justify-center">{children}</div>
    </div>
  )
}

export default StatCard
